import { faStar } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { wikiAddExperienceUrl } from "@/mk2/apps/wiki/urls";
import { wikiArticleUrl } from "@/mk2/apps/wiki/utils";
import { Dot } from "@/mk2/components/Dot";
import { Link } from "@/mk2/components/Link";
import { Panel } from "@/mk2/components/Panel";
import { PanelHeading } from "@/mk2/components/PanelHeading";
import { url } from "@/mk2/helpers/urls";
import { WikiArticleEntity } from "@/mk2/schemas";
import { interpolate } from "@/mk2/services/i18n";
import {
    RELATED_REVIEW_ARTICLES,
    TO_REVIEW_CENTRE,
    WIKI_WRITE_YOUR_EXPERIENCE,
    WIKI_WRITE_YOUR_FIRST_EXPERIENCE,
    count_WIKI_ARTICLE_EXPERIENCES,
} from "@/mk/autogenerated/translation";

import styles from "./PostDetailRelated.mscss";

interface OwnProps {
    isContest: boolean;
    linkedReviewArticles?: WikiArticleEntity[];
}

export function LinkedReviewArticlesPanel({ isContest, linkedReviewArticles }: OwnProps) {
    if (isContest || !linkedReviewArticles || linkedReviewArticles.length === 0) {
        return null;
    }

    return (
        <Panel className={styles.PostDetailRelated__box}>
            <PanelHeading title={RELATED_REVIEW_ARTICLES} headingLevel={2} />
            <ul className={styles.PostDetailRelated__linkedArticles}>
                {linkedReviewArticles.map((article) => {
                    const approvedExperiences = (article.experiences || []).filter(
                        (exp) => exp.approved && !exp.deleted,
                    );
                    const shownCount = 2;

                    return (
                        <li
                            key={article.id}
                            className={styles.PostDetailRelated__linkedArticlesItem}
                        >
                            <div className={styles.PostDetailRelated__linkedArticlesItemHeader}>
                                <Link to={wikiArticleUrl(article, "experiences")}>
                                    <b>{article.title}</b>
                                </Link>
                                {article.experiencesStarsAllowed &&
                                    article.experiencesCount > 0 && (
                                        <span
                                            className={
                                                styles.PostDetailRelated__linkedArticlesItemStars
                                            }
                                        >
                                            {article.experiencesScore.toFixed(1).replace(".", ",")}
                                            &nbsp;
                                            <FontAwesomeIcon
                                                icon={faStar}
                                                className={styles.PostDetailRelated__star}
                                            />
                                            <Dot spaces={1} />
                                        </span>
                                    )}
                                {article.experiencesStarsAllowed &&
                                    article.experiencesCount > 0 && (
                                        <span
                                            className={
                                                styles.PostDetailRelated__linkedArticlesItemCount
                                            }
                                        >
                                            {interpolate(count_WIKI_ARTICLE_EXPERIENCES, {
                                                count: article.experiencesCount,
                                            })}
                                        </span>
                                    )}
                            </div>
                            {approvedExperiences.length > 0 ? (
                                <>
                                    {approvedExperiences.slice(0, shownCount).map((exp) => (
                                        <div
                                            key={exp.id}
                                            className={styles.PostDetailRelated__experienceSnippet}
                                        >
                                            <Link
                                                to={wikiArticleUrl(article, `experience-${exp.id}`)}
                                            >
                                                {exp.title}
                                            </Link>
                                        </div>
                                    ))}
                                    <div className={styles.PostDetailRelated__experienceAction}>
                                        <Link
                                            to={url(wikiAddExperienceUrl, {
                                                categorySlug: article.category.slug,
                                                articleSlug: article.slug,
                                            })}
                                        >
                                            {WIKI_WRITE_YOUR_EXPERIENCE}
                                        </Link>
                                    </div>
                                </>
                            ) : (
                                <div className={styles.PostDetailRelated__experienceAction}>
                                    <Link
                                        to={url(wikiAddExperienceUrl, {
                                            categorySlug: article.category.slug,
                                            articleSlug: article.slug,
                                        })}
                                    >
                                        {WIKI_WRITE_YOUR_FIRST_EXPERIENCE} {TO_REVIEW_CENTRE}
                                    </Link>
                                </div>
                            )}
                        </li>
                    );
                })}
            </ul>
        </Panel>
    );
}
